import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClipLoader } from 'react-spinners';

import {
  BackButton,
  LoginPip,
  Callout,
  BrandSoftHint,
  Foot,
} from 'components/LoginModal/parts';

const EmailConfirmation = ({ isResending, handleResend, onBack, email }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="px-6 sm:px-9 pt-9 pb-0">
        <BackButton label={t('login.back_to_login')} onClick={onBack} />
        <LoginPip />
        <div className="font-display text-[11px] font-bold uppercase tracking-[0.14em] text-yellow-04 mt-4">
          {t('login.confirm_email_eyebrow', 'Confirm your email')}
        </div>
        <h2 className="font-serif font-normal text-[30px] sm:text-[36px] leading-[1.05] tracking-[-0.01em] text-ink mt-2 mb-0">
          {t('login.confirm_email_title', 'One last step.')}
        </h2>
        <p className="mt-2.5 text-[14px] leading-[1.5] text-muted-2">
          {t('login.unconfirmed_notice')}
        </p>
      </div>

      <div className="px-6 sm:px-9 pt-6 pb-7 flex flex-col gap-4">
        <Callout k={t('login.sent_to', 'Sent to')} v={email} />
        <BrandSoftHint>
          {t(
            'login.spam_hint',
            "Didn't get it? Check your spam folder, or resend below."
          )}
        </BrandSoftHint>
        <button
          type="button"
          onClick={handleResend}
          disabled={isResending}
          className="w-full inline-flex items-center justify-center gap-2 rounded-full
                     bg-white text-ink border border-line-strong px-5 py-4 text-[15px] font-semibold
                     hover:bg-paper-2 hover:border-ink disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isResending ? (
            <ClipLoader color="#1A1A1F" size={16} />
          ) : (
            t('login.resend_confirmation')
          )}
        </button>
      </div>

      <Foot>
        <span>{t('login.wrong_email', 'Wrong email?')}</span>
        <button
          type="button"
          onClick={onBack}
          className="font-bold text-ink underline underline-offset-[3px] hover:text-yellow-04"
        >
          {t('login.use_another_account', 'Use another account')}
        </button>
      </Foot>
    </>
  );
};

export default EmailConfirmation;
